// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { userMixins } from "@/app/mixins/modules/user-mixins.js"

// Util
import { vuelidateUtil } from "@/utils/vuelidate-util.js"

// Third Party libraries
import * as $ from "jquery"

// Services
import TransactionService from "@/app/services/main/transaction/transaction-service";
import SubscriptionService from "@/app/services/main/subscription/subscription-service";

// Constants
import { STATUS_CODES, CANCELLATION_TYPE } from "@/app/constants/status-constants"

export default {
	name: "ModalCancelOrder",
	mixins: [toastMessageMixins, userMixins],
	props: {
        contentTitle: {
			type: String,
            required: true,
        },
        contentBody: {
			type: String,
            required: true,
			default: "Are you sure you want to proceed? Please state your reason in the textbox below.",
        },
		cancellationType: {
			type: String,
			required: true,
		},
    },
	data() {
		return {
			cancelText: "",
			isAPILoading: false,
			product: null,
		}
	},
	computed: {
		validationRules() {
			let field = {
				cancelText: {},
			}

			field = vuelidateUtil.setRequiredValidation(field, "cancelText")

			return field
		},
	},
	mounted() {
		$(this.$refs.modalCancelOrder).on("hide.bs.modal", this.handleHideEvent)
	},
	beforeDestroy() {
		this.closeModal()
		$(this.$refs.modalCancelOrder).off("hide.bs.modal", this.handleHideEvent)
	},
	methods: {
		openModal(orderDetails) {
			this.resetFields()
			this.product = orderDetails
			$(this.$refs.modalCancelOrder).modal("show")
		},
		closeModal() {
			$(this.$refs.modalCancelOrder).modal("hide")
		},
		resetFields() {
			this.cancelText = ""
			this.$v.$reset()
			this.product = null
		},
		handleHideEvent() {
			this.$emit("returnToOrderDetails", this.product)
		},
		async submitCancellation() {
			if (this.$v.$invalid) {
				return
			}

			this.isAPILoading = true

			if(this.cancellationType === CANCELLATION_TYPE.PRODUCT_REFUND){
				TransactionService.putCancelDogOrder(this.product.id, {
					reason: this.cancelText,
					products: this.product.bundles,
					totalPrice: this.product.totalPrice,
				})
					.then((res) => {
						const { SUCCESS_CANCEL_ORDER, ERROR_CANCEL_ORDER } = this.toastMessages.order()
						if (res.status === STATUS_CODES.SUCCESS) {
							this.showCustomSuccessToast(SUCCESS_CANCEL_ORDER)
							this.closeModal()
							this.$emit("orderedCancelled")
						} else {
							this.showAPIErrorToast(ERROR_CANCEL_ORDER, res)
						}
						this.isAPILoading = false
					})
					.catch(() => {
						this.showGenericErrorToast()
						this.isAPILoading = false
					})
			}
			else if(this.cancellationType === CANCELLATION_TYPE.SUBSCRIPTION_CANCELLATION){
				const {id: subscriptionId, petId, orderDetails} = this.product;

				const subscriptionDetails = {
					orderId: orderDetails.id,
					remarks: this.cancelText,
				};

				const { SUCCESS_REQUEST_CANCEL, ERROR_REQUEST_CANCEL } = this.toastMessages.subscription();

				try{
					const response = await SubscriptionService.requestSubscriptionCancellation(petId, subscriptionId, subscriptionDetails);
					
					if(response.status === STATUS_CODES.SUCCESS_NO_CONTENT){
						this.showCustomSuccessToast(SUCCESS_REQUEST_CANCEL);
						this.closeModal();
						this.$emit("orderedCancelled")
					}
					else{
						this.showAPIErrorToast(ERROR_REQUEST_CANCEL);
					}

					this.isAPILoading = false;
				}
				catch(err){
					this.showGenericErrorToast();
					this.isAPILoading = false;
				}
			}
		},
	},
	validations() {
		return this.validationRules
	},
}
